import React, { useState, useContext } from 'react';
import styled from 'styled-components';
import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import { DropzoneArea } from 'material-ui-dropzone';
import CardTitle from '../../../common/card/CardTitle';
import { UserContext } from '../../../user/User.context';
import UserLink from '../../users/components/UserLink';
import { formatDate, formatSize } from '../../../common/formatter';

const StyleTableHead = styled(TableHead)`
  text-transform: uppercase;
`;

const AttachmentView = styled.div`
  padding: 20px;
`;

const StyledTableCell = styled(TableCell)`
  white-space: normal;
  word-wrap: break-word;
`;
export interface JiraAttachmentCardProps {
  issue: any;
}

export interface Attachment {
  files: File[];
  uploadedBy: any;
  uploadDate: Date;
}

const JiraAttachmentCard: React.FC<JiraAttachmentCardProps> = ({ issue }) => {
  const { user } = useContext(UserContext);
  const [attachments, setAttachments] = useState<Attachment[]>();

  return (
    <Card>
      <CardTitle>
        <AttachFileIcon />
        Attachments
      </CardTitle>
      <AttachmentView>
        <DropzoneArea
          showAlerts={false}
          showFileNamesInPreview={true}
          onChange={(file: any) => {
            setAttachments([
              {
                files: file,
                uploadedBy: user,
                uploadDate: new Date()
              }
            ]);
          }}
        />
      </AttachmentView>
      {attachments && (
        <Table>
          <StyleTableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Uploaded By</TableCell>
              <TableCell>Size</TableCell>
              <TableCell>Uploaded Date</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </StyleTableHead>
          <TableBody>
            {attachments.map((item: any) => {
              return item.files.map((file: any, index: number) => {
                return (
                  <TableRow key={index}>
                    <StyledTableCell>{file.name}</StyledTableCell>
                    <TableCell>
                      <UserLink type='name' user={item.uploadedBy} />
                    </TableCell>
                    <TableCell>{formatSize(file.size)}</TableCell>
                    <TableCell>{formatDate(item.uploadDate)}</TableCell>
                    <TableCell>
                      <CloseIcon />
                    </TableCell>
                  </TableRow>
                );
              });
            })}
          </TableBody>
        </Table>
      )}
    </Card>
  );
};

export default JiraAttachmentCard;
